import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminCreateProviderDepartmentOptionMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminCreateProviderDepartmentOptionMutationResultFragment, AdminCreateProviderDepartmentOptionMutationParams } from '@docpace/admin-graphql'

const typedAdminCreateProviderDepartmentOptionMutationDocument = AdminCreateProviderDepartmentOptionMutationDocument as TypedDocumentNode<AdminCreateProviderDepartmentOptionMutationResultFragment, Partial<AdminCreateProviderDepartmentOptionMutationParams>>

export function useAdminCreateProviderDepartmentOptionMutation(opts?: useMutation.Options<AdminCreateProviderDepartmentOptionMutationResultFragment, Partial<AdminCreateProviderDepartmentOptionMutationParams>>){
    return useMutation(typedAdminCreateProviderDepartmentOptionMutationDocument, opts)
}
